module.exports = {
      id: "profile-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#profile",
      toString: function () {
        return this.url;
      }
    }